import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const truckClassParamsSchema = object({
  truckClassId: stringToNumber()
})
